module.exports = __webpack_public_path__ + "img/map-rivervale.7054033a.webp";